/** Navigation only; readiness remains the authority for business state. */
export const PREPARATION_SECTIONS = [
  "authorization",
  "specification",
  "census",
  "insurers",
  "review",
] as const;
export function preparationSection(value: string | null | undefined) {
  return PREPARATION_SECTIONS.find((section) => section === value);
}
export function preparationHref(requestId: string, section?: string | null) {
  const selected = preparationSection(section);
  return `/quote-requests/${encodeURIComponent(requestId)}/preparer${selected ? `?section=${selected}` : ""}`;
}
export function censusPreparationHref(projectId: string, requestId: string) {
  const params = new URLSearchParams({
    view: "preparation",
    request: requestId,
    request_section: "specification",
  });
  return `/projects/${encodeURIComponent(projectId)}?${params}#census`;
}

/** File navigation keeps the selected request explicit, without creating business state. */
export function dossierPreparationHref(
  projectId: string,
  requestId?: string | null,
  section?: string | null,
) {
  const params = new URLSearchParams({ view: "preparation" });
  if (requestId) params.set("request", requestId);
  const selected = preparationSection(section);
  if (selected) params.set("request_section", selected);
  return `/projects/${encodeURIComponent(projectId)}?${params}`;
}

export const PROJECT_VIEWS = [
  "overview",
  "preparation",
  "insurers",
  "comparison",
  "documents",
] as const;

/** Only navigation fields survive an import round trip; never accept a return URL. */
function projectNavigationSearch(search: string) {
  const input = new URLSearchParams(search);
  const output = new URLSearchParams();
  const view = PROJECT_VIEWS.find((value) => value === input.get("view"));
  if (view) output.set("view", view);
  const request = input.get("request");
  if (request) output.set("request", request);
  const section = preparationSection(input.get("request_section"));
  if (section) output.set("request_section", section);
  return output.size ? `?${output}` : "";
}

export function projectSubmissionImportHref(
  projectId: string,
  location: { pathname: string; search: string },
) {
  const path = `/projects/${encodeURIComponent(projectId)}`;
  return `${path}/submissions/new${location.pathname === path ? projectNavigationSearch(location.search) : ""}`;
}

export function projectSubmissionReturnHref(projectId: string, search: string) {
  return `/projects/${encodeURIComponent(projectId)}${projectNavigationSearch(search)}`;
}
